// Breadcrumbs on scroll is hidden
window.addEventListener('load', function(){
    
var elementPosition = $('#desktop-header .breadcrumb-collection').offset();

$(window).scroll(function(){
    if (elementPosition !== undefined) {
        if($(window).scrollTop() > elementPosition.top){
            $('#desktop-header .breadcrumb-collection').css('position','fixed').css('top','0');
            $('#desktop-header .breadcrumb-collection').css('display','none');
            $('#desktop-header .breadcrumb-collection').css('width','100%');
        } else {
            $('#desktop-header .breadcrumb-collection').css('position','static');
            $('#desktop-header .breadcrumb-collection').css('display','block');
        }   
    }     
});



    let programsRelatedProducts = document.querySelectorAll('.programs__related-products-list');

    if(programsRelatedProducts.length > 0) {
        programsRelatedProducts.forEach((el, i) => {
            var flkty = new Flickity( el, {
            cellAlign: 'left',
            contain: true,
            pageDots: false
            });
        })
    }


});

// document.querySelector('header .menu a[href="#"]').addEventListener('click', function(event) {
//   event.preventDefault();
// });